import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { paymentQrValue } from "../lib/payment";

export default function PaymentQrCode({ selfPayment, pricing, payeeName, size = 160 }) {
  const amount = pricing?.effective_amount ?? pricing?.amount;
  const value = paymentQrValue({
    payment_link: selfPayment?.payment_link,
    payment_upi: selfPayment?.payment_upi,
    amount,
    currency: pricing?.currency,
    payeeName,
  });
  if (!value) return null;
  return (
    <div
      className="rounded-card border border-black/[0.06] bg-white p-3 inline-block"
      data-testid="payment-qr-code"
    >
      <QRCodeSVG value={value} size={size} level="M" includeMargin />
    </div>
  );
}
